import httpClient from './httpClient';

export const fetchTutorSchedules = (tutorId, weekStart) => {
  const params = weekStart ? { weekStart } : {};
  return httpClient
    .get(`/schedules/tutor/${tutorId}`, { params })
    .then((response) => response.data);
};

export const fetchMySchedules = (weekStart) => {
  const params = weekStart ? { weekStart } : {};
  return httpClient.get('/schedules/me', { params }).then((response) => response.data);
};

export const createScheduleSlot = (payload) =>
  httpClient.post('/schedules', payload).then((response) => response.data);

export const updateScheduleSlot = (id, payload) =>
  httpClient.patch(`/schedules/${id}`, payload).then((response) => response.data);

export const deleteScheduleSlot = (id) => httpClient.delete(`/schedules/${id}`);

export const fetchAttentionCount = () =>
  httpClient.get('/schedules/me/attention-count').then((response) => response.data);



